import { YStack } from 'tamagui';
import PSText from './ui/PSText';

/**
 * AccessPassExclusiveHeading — the title + subheading atop the home page's
 * Access Pass Exclusive section (molecule).
 *
 * The subheading's copy is tense-shifted by membership: a member has already
 * unlocked the perks ("What you've unlocked…"), a non-member (or logged-out
 * visitor) has yet to ("What you'll unlock…"). That copy swap is the one piece
 * of behavior here — it's why this is a component and not inlined markup.
 *
 * `isMember` is false for logged-out visitors, so the caller can pass its
 * logged-out state straight through.
 */
type AccessPassExclusiveHeadingProps = {
  isMember: boolean;
};

export default function AccessPassExclusiveHeading({
  isMember,
}: AccessPassExclusiveHeadingProps) {
  return (
    <YStack mt={'$space.md'}>
      <PSText.H3 color={'$color.brandSecondary'}>
        Access Pass Exclusive
      </PSText.H3>
    </YStack>
  );
}
